// see variables.less for typography style overriding

import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import { TextProps } from 'antd/lib/typography/Text';
import { TitleProps } from 'antd/lib/typography/Title';
import classNames from 'classnames';
import './index.less';

export const H1 = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title {...props} level={1}>
      {children}
    </Typography.Title>
  );
};

export const H2 = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title {...props} level={2}>
      {children}
    </Typography.Title>
  );
};

export const H3 = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title {...props} level={3}>
      {children}
    </Typography.Title>
  );
};

export const H4 = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title {...props} level={4}>
      {children}
    </Typography.Title>
  );
};

export const Headline = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title {...props} level={5}>
      {children}
    </Typography.Title>
  );
};

export const Title = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title
      {...props}
      level={5}
      className={classNames('revx-title', props.className)}
    >
      {children}
    </Typography.Title>
  );
};

export const SectionHeading = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title
      {...props}
      level={4}
      className={classNames('revx-section-heading', props.className)}
    >
      {children}
    </Typography.Title>
  );
};

export const SubHeading = ({ children, ...props }: TitleProps) => {
  return (
    <Typography.Title
      {...props}
      level={5}
      className={classNames('revx-sub-heading', props.className)}
    >
      {children}
    </Typography.Title>
  );
};

export const Text = ({ children, ...props }: TextProps) => {
  return (
    <Typography.Text
      {...props}
      className={classNames('revx-text', props.className)}
    >
      {children}
    </Typography.Text>
  );
};

export const TextHeavy = ({ children, ...props }: TextProps) => {
  return (
    <Typography.Text
      {...props}
      className={classNames('revx-text-heavy', props.className)}
    >
      {children}
    </Typography.Text>
  );
};

export const TextGrey = ({ children, ...props }: TextProps) => {
  return (
    <Typography.Text
      {...props}
      className={classNames('revx-text-grey', props.className)}
    >
      {children}
    </Typography.Text>
  );
};

export const Caption = ({ children, ...props }: TextProps) => {
  return (
    <Typography.Text
      {...props}
      className={classNames('revx-caption', props.className)}
    >
      {children}
    </Typography.Text>
  );
};

export const Paragraph = ({ children, ...props }: ParagraphProps) => {
  return (
    <Typography.Paragraph
      {...props}
      className={classNames('revx-paragraph', props.className)}
    >
      {children}
    </Typography.Paragraph>
  );
};

export const UnderlineText = ({
  children,
  color,
  bold,
  size = 'default',
  ...props
}: TitleProps & {
  color: 'blue' | 'green' | 'gray';
  bold?: boolean;
  size?: 'small' | 'default' | 'large';
}) => {
  return (
    <Typography.Title
      {...props}
      level={5}
      className={classNames('revx-underline-text', color, props.className, {
        bold: bold,
        small: size === 'small',
        large: size === 'large',
      })}
    >
      {children}
    </Typography.Title>
  );
};
